const AUTH_STORAGE_KEY = 'jp_auth_user';
export const AUTH_CHANGED_EVENT = 'jp-auth-changed';

const parseJson = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const getAuthUser = () => {
  return parseJson(localStorage.getItem(AUTH_STORAGE_KEY), null);
};

export const isAuthenticated = () => {
  return Boolean(getAuthUser());
};

export const setAuthUser = (user) => {
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
};

export const clearAuthUser = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
};

const getSavedJobsKey = () => {
  const user = getAuthUser();
  const safeIdentifier = user?.email || 'guest';
  return `jp_saved_jobs_${safeIdentifier.toLowerCase()}`;
};

export const getSavedJobs = () => {
  return parseJson(localStorage.getItem(getSavedJobsKey()), []);
};

export const isJobSaved = (jobId) => {
  const targetId = String(jobId);
  return getSavedJobs().some((job) => String(job.id) === targetId);
};

export const saveJob = (job) => {
  const jobs = getSavedJobs();
  const targetId = String(job.id);

  if (jobs.some((item) => String(item.id) === targetId)) {
    return false;
  }

  const nextJobs = [
    {
      ...job,
      savedAt: new Date().toISOString()
    },
    ...jobs
  ];

  localStorage.setItem(getSavedJobsKey(), JSON.stringify(nextJobs));
  return true;
};

export const unsaveJob = (jobId) => {
  const targetId = String(jobId);
  const jobs = getSavedJobs();
  const nextJobs = jobs.filter((job) => String(job.id) !== targetId);

  if (nextJobs.length === jobs.length) {
    return false;
  }

  localStorage.setItem(getSavedJobsKey(), JSON.stringify(nextJobs));
  return true;
};

export const toggleSavedJob = (job) => {
  if (isJobSaved(job.id)) {
    unsaveJob(job.id);
    return false;
  }

  saveJob(job);
  return true;
};
